import axios from "axios";
import qs from "qs";
import Cookies from "js-cookie";
import { ACCOUNT } from "@/utils/constant";

/**
 * 创建xhr实例
 * 路径前缀
 * 超时失败时间
 */
const service = axios.create({
  timeout: 500000,
  async: true,
  crossDomain: true,
  withCredentials: true,
  baseURL: "/",
});

/**
 * @desc 设置服务请求拦截器
 * 定义token请求设置
 */

service.interceptors.request.use(
  (config) => {
    if (config.url.startsWith("/auth")) {
      return config;
    }
    config.headers.Authorization = Cookies.get("token");
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

/**
 * @desc 设置服务响应拦截器
 * 截取返回状态 统一定义成功失败
 */
service.interceptors.response.use(
  (response) => {
    const { url } = response.config;
    const status = response.status;
    const data = response.data;
    if(status === 200) { 
        return Promise.resolve(data);
    } else {
      return Promise.reject(data);
    }
  },
  (err) => { 
    return Promise.resolve(err);
  }
);

function formatParam(param = {}) {
  if (Object.prototype.toString.call(param) === "[object URLSearchParams]") {
    return param;
  }
  Object.keys(param).forEach((key) => {
    if (param[key] === undefined || param[key] === null) {
      param[key] = "";
    }
  });
  return param;
}

const strategy = {
  postForm(param) {
    param = formatParam(param);
    const config = {};
    config.method = "post";
    config.data = qs.stringify(param);
    return config;
  },
  post(param) {
    param = formatParam(param);
    const config = {};
    config.method = "post";
    config.data = param;
    return config;
  },
  get(param) {
    param = formatParam(param);
    const config = {};
    config.method = "get";
    config.params = param;
    return config;
  },
  put(param) {
    param = formatParam(param);
    const config = {};
    config.method = "put";
    config.data = param;
    return config;
  },
  delete(param) {
    param = formatParam(param);
    const config = {};
    config.method = "delete";
    config.params = param;
    return config;
  },
  patch(param) {
    param = formatParam(param);
    const config = {};
    config.method = "patch";
    config.data = param;
    return config;
  },
  download(param) {
    param = formatParam(param);
    const config = {
      responseType: "blob",
    };
    config.method = "post";
    config.data = param;
    return config;
  },
};

const request = (url, method = "get", param) => {
  method = method.toLowerCase();
  const config = strategy[method](param);
  let res = {};
  try {
    res = service({
      url,
      ...config,
    });
    return res;
  } catch (e) {
    // 解决界面上报错的问题
    return res;
  }
};

export const get = (url, params) => { 
  return request(url, "get", params);
};

export const post = (url, params) => {
  return request(url, "post", params);
};

export const postForm = (url, params) => {
  return request(url, "postForm", params);
};

export const deleteRequest = (url, params) => {
  return request(url, "delete", params);
};

export const put = (url, params) => {
  return request(url, "put", params);
};
export const patch = (url, params) => {
  return request(url, "patch", params);
};
export const download = (url, params) => {
  return request(url, "download", params);
};

export default request;
